export default __webpack_public_path__ + "static/media/icon-credit-dot.d08f2098.svg";